export default __webpack_public_path__ + "/_/specialEmoji.62725a56.png";